var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onHandleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "setup-contents" },
            [
              _c(
                "el-form",
                {
                  ref: "refCityForm",
                  staticClass: "demo-cityForm",
                  attrs: {
                    "label-width": "170px",
                    model: _vm.cityForm,
                    rules: _vm.cityRules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "照片/视频更新时间：", prop: "time_num" },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入照片/视频更新时间",
                              clearable: "",
                            },
                            model: {
                              value: _vm.cityForm.time_num,
                              callback: function ($$v) {
                                _vm.$set(_vm.cityForm, "time_num", $$v)
                              },
                              expression: "cityForm.time_num",
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "margin-left": "20px",
                                width: "100px",
                              },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.cityForm.time_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "time_type", $$v)
                                },
                                expression: "cityForm.time_type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "天", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "月", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#333333",
                        width: "160px",
                        "text-align": "right",
                        "margin-bottom": "10px",
                      },
                    },
                    [_vm._v(" 超售后率下架： ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "条件1超售后率：",
                        prop: "aftersale_percent",
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "200px" },
                              attrs: {
                                placeholder: "请输入",
                                clearable: "",
                                disabled:
                                  _vm.multi_aftersale_percent == 1
                                    ? true
                                    : false,
                              },
                              model: {
                                value: _vm.cityForm.aftersale_percent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.cityForm,
                                    "aftersale_percent",
                                    $$v
                                  )
                                },
                                expression: "cityForm.aftersale_percent",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "20px" },
                              attrs: { "true-label": 1, "false-label": 0 },
                              on: { change: _vm.checkboxchange },
                              model: {
                                value: _vm.multi_aftersale_percent,
                                callback: function ($$v) {
                                  _vm.multi_aftersale_percent = $$v
                                },
                                expression: "multi_aftersale_percent",
                              },
                            },
                            [_vm._v("默认2倍")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "条件2销量：", prop: "name" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-left": "-10px",
                                "margin-right": "20px",
                                "margin-top": "-3px",
                              },
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "没有条件2时，以条件1为判断标准，存在条件2时，以条件2为判断标准。",
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c("el-button", { attrs: { type: "text" } }, [
                                    _c("i", {
                                      staticClass: "el-icon-info",
                                      staticStyle: { "font-size": "16px" },
                                    }),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入条件2销量",
                              clearable: "",
                            },
                            model: {
                              value: _vm.cityForm.sale_num,
                              callback: function ($$v) {
                                _vm.$set(_vm.cityForm, "sale_num", $$v)
                              },
                              expression: "cityForm.sale_num",
                            },
                          }),
                          _vm._v(" 件 "),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "质检报告更新时间：",
                        prop: "inspection_report_pic_time_num",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入质检报告更新时间",
                              clearable: "",
                            },
                            model: {
                              value:
                                _vm.cityForm.inspection_report_pic_time_num,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cityForm,
                                  "inspection_report_pic_time_num",
                                  $$v
                                )
                              },
                              expression:
                                "cityForm.inspection_report_pic_time_num",
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "margin-left": "20px",
                                width: "100px",
                              },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value:
                                  _vm.cityForm.inspection_report_pic_time_type,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.cityForm,
                                    "inspection_report_pic_time_type",
                                    $$v
                                  )
                                },
                                expression:
                                  "cityForm.inspection_report_pic_time_type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "年", value: 3 },
                              }),
                              _c("el-option", {
                                attrs: { label: "月", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "日", value: 1 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "近10日商品日均销量：",
                        prop: "sales_10_day",
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "请输入", clearable: "" },
                              on: {
                                input: (val) =>
                                  (_vm.cityForm.sales_10_day = val.replace(
                                    /[^\d]/g,
                                    ""
                                  )),
                              },
                              model: {
                                value: _vm.cityForm.sales_10_day,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "sales_10_day", $$v)
                                },
                                expression: "cityForm.sales_10_day",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("件"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }